import AutopayToggle from './components/AutopayToggle';

export const getResidentProfileData = (
  nextPaymentDate: string,
  monthlyRent: string
) => {
  return [
    {
      key: 'Autopay',
      value: <AutopayToggle />,
    },
    {
      key: 'Next payment',
      value: nextPaymentDate,
    },
    {
      key: 'Monthly rent',
      value: monthlyRent,
    },
  ];
};
